import vuei18n from '@/plugins/vue-i18n';
import moment from 'moment';

const status = [
  {
    coverageType: 'DEFAULT',
    states: [
      { 
        text: 'home.status.updateInProgress.title', 
        value: 'UPDATE_IN_PROGRESS',
        description: "home.status.updateInProgress.description"
      },
      { 
        text: 'home.status.voided.title', 
        value: 'VOIDED',
        description: "home.status.voided.description"
      },
      { 
        text: 'home.status.canceled.title', 
        value: 'CANCELED',
        description: "home.status.canceled.description"
      },
      { 
        text: 'home.status.completed.title', 
        value: 'COMPLETED',
        description: "home.status.completed.description"
      },
      { 
        text: 'home.status.inProgress.title', 
        value: 'IN_PROGRESS',
        description: "home.status.inProgress.description"
      },
      { 
        text: 'home.status.error.title', 
        value: 'ERROR',
        description: "home.status.error.description"
      },
      { 
        text: 'home.status.failed.title', 
        value: 'FAILED',
        description: "home.status.failed.description"
      },
      { 
        text: 'home.status.ready.title', 
        value: 'READY',
        description: "home.status.ready.description"
      },
      { 
        text: 'home.status.paid.title', 
        value: 'PAID',
        description: "home.status.paid.description"
      },
    ]
  }
]

const orderBy = [
  {
    text: 'home.order.createdAt',
    value: 'createdAt',
    order: 'desc'
  },
  {
    text: 'home.order.beneficiaryName',
    value: 'beneficiaryName',
    order: 'asc'
  },
]

const documentationItems = [
  { text: 'home.satisfiesDocumentsPolicy.complete', value: 'true' },
  { text: 'home.satisfiesDocumentsPolicy.incomplete', value: 'false' }
]

const types = [
  {
    slug: 'PRESCRIPTION_DRUGS',
    value: 'PRESCRIPTION_DRUGS',
    productType: 'drug',
    text: 'authorizationTypes.medicalTypes.medicines',
  },
  {
    slug: 'DIAGNOSTIC_TESTS',
    value: 'DIAGNOSTIC_TESTS',
    productType: 'laboratory',
    text: 'authorizationTypes.medicalTypes.laboratories',
  },
  {
    slug: 'DIAGNOSTIC_STUDY',
    value: 'DIAGNOSTIC_STUDY',
    productType: 'diagnostic-test',
    text: 'authorizationTypes.medicalTypes.diagnostic_study',
  },
  {
    slug: 'OUTPATIENT_CARE',
    value: 'OUTPATIENT_CARE',
    productType: '',
    text: 'authorizationTypes.medicalTypes.outpatientCare',
  },
  {
    slug: 'MEDICAL_PROCEDURES',
    value: 'MEDICAL_PROCEDURES',
    productType: '',
    text: 'authorizationTypes.medicalTypes.procedure',
  }
]

const authorizationTypes = [
  { 
    text: 'authorizationTypes.medicalTypes.outpatientCare',
    navBarText: 'authorizationTypes.navBar.outpatientCare',
    path: '/authorization/outpatient-care',
    transactionType: 'OUTPATIENT_CARE',
    productType: ''
  },
  {
    text: 'authorizationTypes.medicalTypes.laboratories',
    navBarText: 'authorizationTypes.navBar.laboratories',
    path: '/authorization/laboratories',
    transactionType: 'DIAGNOSTIC_TESTS',
    productType: 'laboratory'
  },
  {
    text: 'authorizationTypes.medicalTypes.diagnostic_study',
    navBarText: 'authorizationTypes.navBar.diagnostic_study',
    path: '/authorization/diagnostic-study',
    transactionType: 'DIAGNOSTIC_TESTS',
    productType: 'diagnostic-test'
  },
  {
    text: 'authorizationTypes.medicalTypes.medicines',
    navBarText: 'authorizationTypes.navBar.medicines',
    path: '/authorization/prescription',
    transactionType: 'PRESCRIPTION_DRUGS',
    productType: ''
  },
  {
    text: 'authorizationTypes.medicalTypes.procedure',
    navBarText: 'authorizationTypes.navBar.procedure',
    path: '/authorization/procedure',
    transactionType: 'MEDICAL_PROCEDURES',
    productType: ''
  }
]

const sponsors = [
  { 
    text: 'sponsors.umbrella', 
    value: 'us-umbrella-corporation',
    features: [
      "BILLING_INFORMATION_REQUIRED"
    ]
  },
  {
    text: 'sponsors.senasa',
    value: 'do-senasa',
    features: [
      "AUTOMATIC_DISPENSATION"
    ]
  },
  { 
    text: 'sponsors.universal', 
    value: 'do-universal',
    features: [
      "AUTOMATIC_DISPENSATION",
      "PRESCRIPTION_PHYSICIAN_SEARCH"
    ],
    documents: [
      {
        slug: "do-medical-procedure-studies-report",
        required: true,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-medical-procedure-prescription",
        required: false,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-medical-procedure-description",
        required: true,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-medical-procedure-pathology-result",
        required: false,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-medical-procedure-anesthesia-file",
        required: false,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-ambulatory-test-form",
        required: true,
        upload: false,
        showOnDetail: true,
      },
    ]
  },
  { 
    text: 'sponsors.primera', 
    value: 'do-primera',
    features: [
      "AUTOMATIC_DISPENSATION"
    ],
    documents: [
      {
        slug: "do-medical-procedure-studies-report",
        required: true,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-medical-procedure-prescription",
        required: false,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-medical-procedure-description",
        required: true,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-medical-procedure-pathology-result",
        required: false,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-medical-procedure-anesthesia-file",
        required: false,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-ambulatory-test",
        required: true,
        upload: false,
        showOnDetail: true,
      },
    ]
  },
  { 
    text: 'sponsors.humano', 
    value: 'do-humano',
    categories: [
      {
        label: vuei18n.t('sponsors.humanoCategories.global'),
        slug: 'global-health-category'
      },
      {
        label: vuei18n.t('sponsors.humanoCategories.platinum'),
        slug: 'platinum-category'
      },
      {
        label: vuei18n.t('sponsors.humanoCategories.conventional'),
        slug: 'conventional-category'
      }
    ],
    features: [
      "AUTOMATIC_DISPENSATION"
    ],
    documents: [
      {
        slug: "do-medical-procedure-studies-report",
        required: true,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-medical-procedure-prescription",
        required: false,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-medical-procedure-description",
        required: true,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-medical-procedure-pathology-result",
        required: false,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-medical-procedure-anesthesia-file",
        required: false,
        upload: true,
        showOnDetail: true,
      },
      {
        slug: "do-ambulatory-test",
        required: true,
        upload: false,
        showOnDetail: true,
      },
    ]
  },
]

const imageExtensions = [
  'jpeg', 'gif', 'png', 'apng', 'svg', 'bmp', 'bmp ico', 'png ico', 'jpg'
]

const preAccountMimeTypes = ["application/pdf"];

const mimeTypeXML = ["text/xml"];
const mimeTypePdf = ["application/pdf"];
const invoiceMimeTypes = ["text/xml", "application/pdf"];

const mimeTypes = ["image/png", "image/jpeg", "application/pdf"]

const sections = {
  authorizations: "authorizations",
  settlements: "settlements"
}

const filtersConfiguration = [
  {
    type: "SELECT",
    text: "home.filters.status",
    items: status,
    multipleSelection: true,
    range: null,
    section: sections.authorizations,
    category: "status",
    mobile: true,
    prependIcon: "info",
    prependAction: true
  },
  {
    type: "SELECT",
    text: "home.filters.satisfiesDocumentsPolicy",
    items: documentationItems,
    multipleSelection: true,
    range: null,
    section: sections.authorizations,
    category: "satisfiesDocumentsPolicy",
    mobile: true,
    prependIcon: null,
    prependAction: false
  },
  {
    type: "DATE-RANGE",
    text: "home.filters.dateRange",
    items: null,
    multipleSelection: null,
    range: true,
    section: sections.authorizations,
    category: "date-range",
    mobile: true,
    minDate: null,
    maxDate: moment().format('YYYY-MM-DD')
  },
  {
    type: "SELECT-SPONSORS",
    text: "settlements.filters.sponsor",
    items: sponsors,
    multipleSelection: false,
    range: null,
    section: sections.settlements,
    category: "sponsors",
    mobile: true
  },
  {
    type: "DATE-RANGE",
    text: "settlements.filters.dateRange",
    items: null,
    multipleSelection: null,
    range: true,
    section: sections.settlements,
    category: "date-range",
    mobile: true,
    minDate: null,
    maxDate: moment().format('YYYY-MM-DD')
  }
]

const voidableClaimStatuses = ['ERROR', 'COMPLETED', 'READY']
const voidableAuthorizationStatuses = ['CREATED', 'READY']

const filesUploadPhase = {
  'AT_CREATION': 'AT_CREATION',
  'POST_CREATION': 'POST_CREATION',
  'ANY': 'ANY'
}

export {
  status,
  types,
  orderBy,
  authorizationTypes,
  imageExtensions,
  mimeTypes,
  sections,
  sponsors,
  filtersConfiguration,
  voidableClaimStatuses,
  voidableAuthorizationStatuses,
  filesUploadPhase,
  preAccountMimeTypes,
  mimeTypeXML,
  mimeTypePdf,
  invoiceMimeTypes
}
